const Footer = () => {
    return (
        <footer className="footer">
            <a href="https://www.linkedin.com/in/mauricio-mr/" target="_blank" rel="noreferrer">
                <button>Let's connect</button>
            </a>
            <p className="footer-quote">"Systems that survive production pressure aren't built by accident — they're built by engineers who understood the failure modes before writing a single line."</p>
        </footer>
    );
};

export default Footer;
